import PropTypes from 'prop-types';
import FeatureRoleList from './FeatureRoleList';
import { AppContainer, AppHeader, AppLeftSection, AppName, CommunityTag } from './styles';

const AppSection = ({ installationName, installationTag, communityTag, features }) => {
  if (!features || features.length === 0) {
    return null;
  }

  return (
    <AppContainer>
      <AppHeader>
        <AppLeftSection>
          <AppName>{installationName || installationTag || 'Unknown App'}</AppName>
          {communityTag && <CommunityTag>{communityTag}</CommunityTag>}
        </AppLeftSection>
      </AppHeader>
      <FeatureRoleList features={features} />
    </AppContainer>
  );
};

AppSection.propTypes = {
  installationTag: PropTypes.string,
  communityTag: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      tag: PropTypes.string,
      alias: PropTypes.string,
      name: PropTypes.string,
      roles: PropTypes.array,
    })
  ),
};

AppSection.defaultProps = {
  installationTag: '',
  communityTag: '',
  features: [],
};

export default AppSection;
